export const IS_SAFARI =
  typeof navigator !== 'undefined' && /Version\/[\d.]+.*Safari/.test(navigator.userAgent);

export const IS_FIREFOX =
  typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox');
